import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import Intl, { IntlCapture } from './common/messages/Intl';
import App from './App';
import translations from './translations';
import LanguageService from 'services/Language.service';

//stays temporarily for any edge case
// import Client from 'services/kenticoClient';

import moment from 'moment';
import 'moment/locale/pl';

export default class LocalizedApp extends Component {
  constructor(props) {
    super(props);
    this.paramLang = props.match.params.lang;
    this.lang = null;

    if (LanguageService.requestCameFromBrowser()) {
      this.lang = LanguageService.getLang();
      // Set correct prefix, after browsers language has been detected
      if (this.paramLang !== this.lang) {
        LanguageService.changePathname(this, this.lang, false);
      }
    } else {
      this.lang = this.paramLang || LanguageService.getLang();
      LanguageService.setLang(this.lang);
    }

    moment.locale(this.lang);
    this.messages = translations[this.lang];
    //stays temporarily for any edge case
    // Client.config.defaultLanguage = this.lang;
  }

  componentDidMount() {
    this.render = this.render.bind(this);

    Intl.load('en')
      .then(({ locale, defaultLocale, messages }) => {
        this.setState({ locale, defaultLocale, messages }, this.render);
      })
      .catch(this.render);
  }

  render() {
    const { props } = this;

    return (
      <IntlProvider locale="en" messages={this.messages}>
        <IntlCapture>
          <App {...props} />
        </IntlCapture>
      </IntlProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/LocalizedApp.js